import React from 'react';
import Styles from './styles.js';
import HeadingSectionV1 from 'components/v1-tailwindcss/HeadingSectionV1';

const data = [
    {
        id: 1,
        title: "Single Renter Profile",
        img: "/static/images/landingPages/ForRenters/Renter.png",
        para: "Sign up once and curate your profile for all your applications and inquiries. Witness your renter profile evovle with time, making it the best reference for landlords"
    },
    {
        id: 1,
        title: "Seamless Online Booking",
        img: "/static/images/landingPages/ForRenters/onlinebooking.png",
        para: "No more paperwork. Our proprietary process enables booking long term homes as easy as booking a hotel"
    },
    {
        id: 1,
        title: "Online Community",
        img: " /static/images/landingPages/ForRenters/onlinecommunity.png",
        para: "Get access to the community app, interact and get to know hundreds of young professionals around you"
    },
    {
        id: 1,
        title: "Integrated Screening",
        img: "/static/images/landingPages/ForRenters/Screening.png",
        para: "New to the country and do not have a credit score? We provide landlords with integrated screening technology which goes beyond local scores"
    },
    {
        id: 1,
        title: "Renter's Portal",
        img: "/static/images/landingPages/ForRenters/Portal.png",
        para: "Simple yet powerful Renter's Portal to raise and track all your requests and information from the respective landlords"
    },
    {
        id: 1,
        title: "No Scams",
        img: "/static/images/landingPages/ForRenters/noscam.png",
        para: "All landlords signed up with SoulRooms are verified ensuring what you see online is what you actually get when you move in."
    },


]

const BenifitsV1 = (props) => {
   
    return (
        <>
            <div className='lg:container px-6  mx-auto mt-12'>

                <HeadingSectionV1 title="BENEFITS OF USING OUR PLATFORMS AS A RENTER"/>


                <div className='grid lg:grid-cols-3  md:grid-cols-2 grid-cols-1  lg:px-2 xl-px-3 justify-center px-4  gap-y-12'>

                    {data.map((people) => {
                        const { id, title, img, para } = people;

                        return (
                            <div key={id} className=' px-5  '>
                                <h1 className='benifit_title text-center text-xl leading-7 font-normal text-gray-900 mt-2 mb-4'>{title}</h1>
                                <img src={img} className='w-full' />


                                <p className='benifit_para text-center mt-4 text-base leading-6 font-normal text-gray-700'>{para}</p>
                            </div>
                        )
                    })}
                </div>
            </div>
            <Styles/>


        </>
    );
};

export default BenifitsV1;
